import {
	AiDecisionSuggestionListResponse,
	AiDecisionSuggestionResponse,
	AiJobResponse,
	StartAiDecisionRequest,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'AiDecision';

export const startAiDecision = async (request: StartAiDecisionRequest): Promise<HttpResponse<AiJobResponse>> => {
	const result = await makeRequest<StartAiDecisionRequest, AiJobResponse>(`${endpoint}`, request, 'post');
	return result;
};

export const getAiDecisionJob = async (jobId: string): Promise<HttpResponse<AiJobResponse>> => {
	const result = await makeRequest<string, AiJobResponse>(`${endpoint}/job/${jobId}`, null, 'get');
	return result;
};

export const getAiDecisionsForCase = async (caseId: string): Promise<HttpResponse<AiDecisionSuggestionListResponse>> => {
	const result = await makeRequest<string, AiDecisionSuggestionListResponse>(`${endpoint}/case/${caseId}`, null, 'get');
	return result;
};

export const getAiDecisionSuggestion = async (suggestionId: string): Promise<HttpResponse<AiDecisionSuggestionResponse>> => {
	const result = await makeRequest<string, AiDecisionSuggestionResponse>(`${endpoint}/${suggestionId}`, null, 'get');
	return result;
};
